import React, { useEffect, useState } from 'react';
import * as Checkbox from '@radix-ui/react-checkbox';
import { CheckIcon } from '@radix-ui/react-icons';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import styles from './shots-bulk-update.modal.module.scss';
export type ShotsBulkUpdateModalProps = {
  shotsCount: number;
  onUpdate: () => void;
  onCancel: () => void;
};

export const ShotsBulkUpdateModal: React.FC<ShotsBulkUpdateModalProps> = ({
  shotsCount = 1,
  onUpdate,
  onCancel,
}) => {
  const [isBulkUpdatePermitted, setIsBulkUpdatePermitted] = useState(false);

  useEffect(() => {
    const isChecked = JSON.parse(localStorage.getItem('isBulkUpdatePermitted') || 'false');
    setIsBulkUpdatePermitted(isChecked);
  }, []);

  const handleCheckboxChange = (checked: boolean) => {
    setIsBulkUpdatePermitted(checked);
  };

  const handleUpdate = () => {
    localStorage.setItem('isBulkUpdatePermitted', JSON.stringify(isBulkUpdatePermitted));
    onUpdate();
    onCancel();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Dialog
      title="Editing multiple shots"
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={handleCancel} />,
        <ElevatedButton
          key="update"
          onClick={handleUpdate}
          text={`Edit ${shotsCount} shots`}
          autoFocus
        />,
      ]}
      secondaryActions={
        <div className={styles['checkbox-container']}>
          <Checkbox.Root
            className="checkbox-root"
            onCheckedChange={handleCheckboxChange}
            defaultChecked={isBulkUpdatePermitted}
            id="bulk-update-checkbox"
          >
            <Checkbox.Indicator className="checkbox-indicator">
              <CheckIcon />
            </Checkbox.Indicator>
          </Checkbox.Root>

          <label htmlFor="bulk-update-checkbox">Don't show again</label>
        </div>
      }
    >
      <div className={styles['content']}>
        You are about to edit multiple selected shots at once. This action cannot be undone.
      </div>
    </Dialog>
  );
};
